// Vendors
import React, { useState } from 'react';

export const formatCompletionDate = (date) => {
  if (!date) return '--';

  // For some reason sometimes the '/'s get removed somewhere in the process.
  const d = date.replace(/\D/g, '');
  return [d.slice(0, 2), '/', d.slice(2, 4), '/', d.slice(4)].join('');
};

export const tablefy = (
  data,
  skipZeroValues = false,
  editable = {},
  props = {}
) => {
  const [isEditing, setIsEditing] = useState('');

  const handleUpdateInputValue = (index, key, value) =>
    setIsEditing(`${index}-${key}`);

  const handleBlur = () => handleSave();

  const handleSave = (key) => {
    setIsEditing('');
    props.handleUpdateProjectDetails();
  };

  return (
    <table className="pip__data-table">
      <tbody>
        {Object.entries(data).map((row, index) => {
          if (row[0] === '' || row[1] === '') return;

          if (skipZeroValues && parseInt(row[1]) === 0) return;

          return (
            <tr key={index}>
              <td>{row[0]}</td>
              <td className="center">
                <strong>
                  {isEditing == `${index}-${row[0]}` ? (
                    <input
                      type="text"
                      value={props.newCompletionDate}
                      onBlur={handleBlur}
                      onChange={(e) =>
                        props.setNewCompletionDate(e.target.value)
                      }
                    />
                  ) : (
                    row[1]
                  )}
                </strong>
              </td>
              {Object.values(editable).includes(row[0]) ? (
                <td>
                  <button
                    className="btn btn--sm"
                    onClick={
                      isEditing === `${index}-${row[0]}`
                        ? () => handleSave(Object.keys(editable)[0])
                        : () =>
                            handleUpdateInputValue(
                              index,
                              row[0],
                              row[1],
                              Object.keys(editable)[0]
                            )
                    }
                  >
                    <span className="btn__content">
                      {isEditing === `${index}-${row[0]}` ? 'Save' : 'Edit'}
                    </span>
                  </button>
                </td>
              ) : (
                <td></td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export const isCompletionDateCorrect = (event) => {
  const completionDate = event.currentTarget.value;
  const dates = completionDate.split('/').map((date) => parseInt(date, 10));
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;

  if (
    dates[0] < 1 || // months
    dates[0] > 12 || // months
    dates[1] < 1 || // days
    dates[1] > 31 || // days
    dates[2] < lastYear || // year
    isNaN(dates[0]) ||
    isNaN(dates[1]) ||
    isNaN(dates[2])
  ) {
    return false;
  } else {
    return true;
  }
};

export const filterProjects = (projects, filter, searchQuery = '') => {
  if (!projects.length) return [];

  searchQuery = searchQuery ? searchQuery.trim().toLowerCase() : '';
  let filteredProjects = [...projects];

  // Find match for builder ID.
  if (filter.builder && filter.builder !== '0') {
    filteredProjects = filteredProjects.filter(
      ({ builder: { ID } }) => filter.builder === ID
    );
  }

  // Find match for status.
  if (filter.status) {
    filteredProjects = filteredProjects.filter(
      ({ status }) => filter.status === status
    );
  }

  // Find match for applicable year.
  if (filter.year) {
    filteredProjects = filteredProjects.filter(
      ({ applicable_year }) => filter.year === applicable_year
    );
  }

  // Find match for state.
  if (filter.state) {
    filteredProjects = filteredProjects.filter(
      ({ state }) => filter.state === state
    );
  }

  // Find match for search query.
  if (searchQuery) {
    filteredProjects = filteredProjects.filter(
      ({
        address,
        builder: { ID, company, user_email, first_name, last_name },
        city,
        pid,
        completion_date,
        zipcode
      }) =>
        // concat all searchable data together and check whether it contains the search string.
        `${address} ${company} ${user_email} ${first_name} ${last_name} ${city} ${completion_date} ${ID} ${pid} ${zipcode}`
          .toLowerCase()
          .includes(searchQuery)
    );
  }

  if (filter.sort) {
    filteredProjects.sort((a, b) => {
      const aLastUpdated = Date.parse(a.last_updated);
      const bLastUpdated = Date.parse(b.last_updated);
      const aCreated = Date.parse(a.created);
      const bCreated = Date.parse(b.created);

      switch (filter.sort) {
        case 'lastUpdated_desc':
          return aLastUpdated < bLastUpdated
            ? 1
            : aLastUpdated > bLastUpdated
            ? -1
            : 0;
        case 'lastUpdated_asc':
          return aLastUpdated > bLastUpdated
            ? 1
            : aLastUpdated < bLastUpdated
            ? -1
            : 0;
        case 'recent_asc':
          return aCreated > bCreated ? 1 : aCreated < bCreated ? -1 : 0;
        case 'recent_desc':
        default:
          return aCreated < bCreated ? 1 : aCreated > bCreated ? -1 : 0;
      }
    });
  }

  return filteredProjects;
};
